var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Renderer2, ElementRef } from '@angular/core';
import { ConfirmModalActions, ConfirmModalData } from './confirm.modal.provider';
import { BaseComponent } from '../base.component';
import { MatDialogRef } from '@angular/material';
var ConfirmModalComponent = /** @class */ (function (_super) {
    __extends(ConfirmModalComponent, _super);
    function ConfirmModalComponent(dialogRef, actions, renderer, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.renderer = renderer;
        _this.isChecked = false;
        _this.data = Object.assign({ confirmModalIcon: 'Exclaim_mk' }, data);
        return _this;
    }
    ConfirmModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    ConfirmModalComponent.prototype.confirm = function (event) {
        var _this = this;
        if (this.data.confirmCheckboxDescription && !this.isChecked) {
            event.immediateComplete();
            // shake the confirm checkbox
            this.renderer.addClass(this.confirmCheckbox.nativeElement, 'ig-shake');
            setTimeout(function () {
                _this.renderer.removeClass(_this.confirmCheckbox.nativeElement, 'ig-shake');
            }, 500);
            return;
        }
        if (this.data.isAsync) {
            var oldFunc_1 = event.complete;
            event.complete = function () {
                oldFunc_1();
                _this.dialogRef.close();
            };
            this.actions.confirm(event);
        }
        else {
            this.actions.confirm(event);
            this.dialogRef.close();
        }
    };
    return ConfirmModalComponent;
}(BaseComponent));
export { ConfirmModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/confirm.modal/confirm.modal.component.ts.pre-build-optimizer.js